module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./TransferView.js"));
	}, "IntegralWalletTransferView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=IntegralWalletTransferView!./src/pages/Shop/Member/Wallet/IntegralTransfer/TransferView.js
// module id = 1943
// module chunks = 367